import VotingStrategy from './index';
import Projects from './Projects';
//import Records from './Records';

export default {
  path: '/home/votingStrategy',
  component: VotingStrategy,
  redirect: '/home/votingStrategy/projects',
  children: [
    { path: '/home/votingStrategy/projects', component: Projects }
    /*{
      path: '/home/votingStrategy/records/:votingStrategyId?',
      component: Records
    }*/
  ]
};
